export enum AppRoutes {
  LOGIN = '',
  PANEL = 'panel',
  PANELPERFUMERIAS = 'panelperfumerias',
  RESET = 'reset'
}
